var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"free_pay_sucess"},[_c('titleBar',{attrs:{"title":_vm.title}}),_c('img',{attrs:{"src":require("../../assets/images/light_lesson/free_pay_success.png")}}),_c('p',{staticClass:"btn",on:{"click":_vm.click_event}},[_vm._v("点击添加")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }